import { TITLE_SMALL_HEIGHT, TITLE_DEFAULT_HEIGHT } from './NavigationCard.constants';
import { CardConfig, CardSize } from './NavigationCard.types';

export const CARD_CONFIGS: Record<CardSize, CardConfig> = {
    sm: {
        size: { height: 193, width: 210 },
        titleHeight: TITLE_DEFAULT_HEIGHT,
        borderRadius: 'xl',
        titleFontSize: 'b_md',
        titleFontWeight: 'bold',
        titleLineHeight: 'b_md',
        titleLineClamp: 2,
        gradientBorderRadius: '6px',
    },
    md: {
        size: { height: 253, width: 266 },
        titleHeight: TITLE_SMALL_HEIGHT,
        borderRadius: '2xl',
        titleFontSize: 'b_md',
        titleFontWeight: 'bold',
        titleLineHeight: 'b_md',
        titleLineClamp: 1,
        gradientBorderRadius: '8px',
    },
    lg: {
        size: { height: 344, width: 380 },
        titleHeight: TITLE_SMALL_HEIGHT,
        borderRadius: '2xl',
        titleFontSize: 'b_md',
        titleFontWeight: 'semibold',
        titleLineHeight: 'b_md',
        titleLineClamp: 1,
        gradientBorderRadius: '8px',
    },
    xl: {
        size: { height: 464, width: 524 },
        titleHeight: 'auto',
        borderRadius: '2xl',
        titleFontSize: 'b_xl',
        titleFontWeight: 'bold',
        titleLineHeight: 'b_xl',
        titleLineClamp: 1,
        gradientBorderRadius: '8px',
    },
} as const;
